export default __webpack_public_path__ + "static/media/logo_text.3653d593.png";